import firebase from 'firebase/app'
import 'firebase/firestore'
import MergeHelpers from '../helpers/MergeHelpers'
import StringHelpers from '../helpers/StringHelpers'
import Firestore from './Firestore'

var fs = firebase.firestore()

export default class {



static runActions(item) {
    return new Promise( (resolve, reject) => {
        let actionsPath = Firestore.replaceDataInPath(item._path, 'actions')
        let ref = fs.collection(actionsPath)
        Firestore.fetchCollection(ref).then(actions => {
            actions.forEach(action => { this.runAction(action, item) })
            resolve(item)
        })
    })
}

//mutates item

static runAction(action, item) {

    let expression = this.merge(action.expression, item)
    let result = ''
    try {
        result = eval(expression)
    } catch (e) {
        result = expression
    }

    console.log('result is ', result)
    let fieldSlug = StringHelpers.toCamelCase(action.field)

    if(action.type == 'Set Field Value') {
        item[fieldSlug] = result
    }

}

static merge(expression, item) {
    let mergeItems = MergeHelpers.findMergeFields(expression)
    
    mergeItems.forEach(mergeItem => {
        let fieldSlug = StringHelpers.toCamelCase(mergeItem)
        let fieldInBrackets = '(\\[' + mergeItem + '\\])'
        let replacement = item[fieldSlug] || ''
        let re = new RegExp(fieldInBrackets, 'gi')
        expression = expression.replace(re, replacement)
    })
    
    return expression
}


} // end class


// WEBPACK FOOTER //
// ./src/data/Actions.js